// React
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Check } from 'lucide-react';
import { useSelector } from 'react-redux';

// Futurelab
import { RootState } from '../../reducers';
import { UserDetailsListItem } from '../../model';
import { isSameUserId, toUserId } from '../../utilities/UserId';

// 3rd Party
import moment from 'moment';

export function ChatListChatRequestChatRoom() {
	const chatInFocus = useSelector((state: RootState) => state.chatInFocus);
	const loggedInUserDetails = useSelector((state: RootState) => state.loggedInUserDetails);
	const userListProfilesDetails = useSelector((state: RootState) => state.userListProfilesDetails);
	const navigate = useNavigate();

	useEffect(() => {
		if (!chatInFocus) {
			navigate('/chat');
		}
	}, []);

	const getChatAdmin = (): UserDetailsListItem | undefined => {
		return userListProfilesDetails.find((userProfileDetails) => {
			if (!chatInFocus?.chatAdmins || !chatInFocus?.chatAdmins[0]) {
				return null;
			}
			return userProfileDetails.id === chatInFocus?.chatAdmins[0].userId;
		});
	};

	const getLoggedInUserDetails = (): UserDetailsListItem | undefined => {
		const loggedInUserId = toUserId(loggedInUserDetails.id);

		return userListProfilesDetails.find((userProfileDetails) => {
			return isSameUserId(userProfileDetails.id, loggedInUserId);
		});
	};

	return (
		<div className="h-full min-h-0 overflow-y-auto bg-gray-50 px-3 sm:px-5">
				<div className="my-5 text-center text-sm text-gray-500">
					{moment(chatInFocus?.createdAt).format('dddd, MMMM Do YYYY')}
				</div>
				<div className="w-4/5 pb-1 pt-4 text-sm text-gray-600 sm:w-3/4 md:w-2/3">
					<span className="truncate capitalize text-sm font-medium text-gray-900 underline">
						{getChatAdmin()?.firstname} {getChatAdmin()?.lastname ?? ''}
					</span>{' '}
					(Admin)
				</div>
				<div className="w-4/5 break-words rounded-lg border border-solid bg-white px-3 py-2.5 text-sm text-gray-900 shadow-sm sm:w-3/4 md:w-2/3">
					Hello {getLoggedInUserDetails()?.firstname}. You've been invite to this chatroom. Have a good day!
				</div>
				<div className="mb-2.5 mt-1.5 text-xs text-gray-500">
					{moment(chatInFocus?.createdAt).format('h:mma')}
					<Check className="read-receipt-font-size inline" />
				</div>
		</div>
	);
}
